// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background: #979696;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.container {
    width: 100%;
    max-width: 500px;
}

.validator-card {
    background: white;
    border-radius: 20px;
    padding: 40px;
    box-shadow: 0 20px 40px rgba(0,0,0,0.1);
}

h1 {
    color: #333;
    text-align: center;
    margin-bottom: 10px;
    font-weight: 600;
}

.subtitle {
    text-align: center;
    color: #666;
    margin-bottom: 30px;
    font-size: 14px;
}

.card-input-container {
    position: relative;
    margin-bottom: 30px;
}

.card-icon {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    font-size: 20px;
}

.card-input {
    width: 100%;
    padding: 15px 15px 15px 50px;
    border: 2px solid #e1e5e9;
    border-radius: 10px;
    font-size: 18px;
    transition: all 0.3s;
    outline: none;
}

.card-input:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.payment-systems {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.payment-system {
    width: 50px;
    height: 30px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.3;
    transition: opacity 0.3s;
    border-radius: 4px;
}

.payment-system:hover {
    opacity: 1;
}

.payment-system.active {
    opacity: 1;
}

.result {
    text-align: center;
    padding: 15px;
    border-radius: 10px;
    margin-top: 20px;
    display: none;
}

.result.valid {
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
    display: block;
}

.result.invalid {
    background: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    display: block;
}

.result-icon {
    font-size: 24px;
    margin-right: 10px;
}

.instructions {
    background: #f8f9fa;
    padding: 20px;
    border-radius: 10px;
    margin-top: 30px;
    font-size: 14px;
}

.instructions h3 {
    margin-bottom: 10px;
    color: #333;
}

.instructions ul {
    padding-left: 20px;
    color: #666;
}

.instructions li {
    margin-bottom: 5px;
}

.example-cards {
    margin-top: 15px;
    font-size: 12px;
    color: #888;
}

.card-input.error {
    border-color: #dc3545 !important;
    background-color: #fff5f5;
}

.card-input.valid {
    border-color: #28a745 !important;
    background-color: #f0fff4;
}

@media (max-width: 600px) {
    .validator-card {
        padding: 25px;
    }
    
    .card-input {
        font-size: 16px;
    }
    
    .payment-system {
        width: 40px;
        height: 25px;
    }
}`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,4DAA4D;IAC5D,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    background: #979696;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n}\n\n.container {\n    width: 100%;\n    max-width: 500px;\n}\n\n.validator-card {\n    background: white;\n    border-radius: 20px;\n    padding: 40px;\n    box-shadow: 0 20px 40px rgba(0,0,0,0.1);\n}\n\nh1 {\n    color: #333;\n    text-align: center;\n    margin-bottom: 10px;\n    font-weight: 600;\n}\n\n.subtitle {\n    text-align: center;\n    color: #666;\n    margin-bottom: 30px;\n    font-size: 14px;\n}\n\n.card-input-container {\n    position: relative;\n    margin-bottom: 30px;\n}\n\n.card-icon {\n    position: absolute;\n    left: 15px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #999;\n    font-size: 20px;\n}\n\n.card-input {\n    width: 100%;\n    padding: 15px 15px 15px 50px;\n    border: 2px solid #e1e5e9;\n    border-radius: 10px;\n    font-size: 18px;\n    transition: all 0.3s;\n    outline: none;\n}\n\n.card-input:focus {\n    border-color: #667eea;\n    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.payment-systems {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n}\n\n.payment-system {\n    width: 50px;\n    height: 30px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    opacity: 0.3;\n    transition: opacity 0.3s;\n    border-radius: 4px;\n}\n\n.payment-system:hover {\n    opacity: 1;\n}\n\n.payment-system.active {\n    opacity: 1;\n}\n\n.result {\n    text-align: center;\n    padding: 15px;\n    border-radius: 10px;\n    margin-top: 20px;\n    display: none;\n}\n\n.result.valid {\n    background: #d4edda;\n    color: #155724;\n    border: 1px solid #c3e6cb;\n    display: block;\n}\n\n.result.invalid {\n    background: #f8d7da;\n    color: #721c24;\n    border: 1px solid #f5c6cb;\n    display: block;\n}\n\n.result-icon {\n    font-size: 24px;\n    margin-right: 10px;\n}\n\n.instructions {\n    background: #f8f9fa;\n    padding: 20px;\n    border-radius: 10px;\n    margin-top: 30px;\n    font-size: 14px;\n}\n\n.instructions h3 {\n    margin-bottom: 10px;\n    color: #333;\n}\n\n.instructions ul {\n    padding-left: 20px;\n    color: #666;\n}\n\n.instructions li {\n    margin-bottom: 5px;\n}\n\n.example-cards {\n    margin-top: 15px;\n    font-size: 12px;\n    color: #888;\n}\n\n.card-input.error {\n    border-color: #dc3545 !important;\n    background-color: #fff5f5;\n}\n\n.card-input.valid {\n    border-color: #28a745 !important;\n    background-color: #f0fff4;\n}\n\n@media (max-width: 600px) {\n    .validator-card {\n        padding: 25px;\n    }\n    \n    .card-input {\n        font-size: 16px;\n    }\n    \n    .payment-system {\n        width: 40px;\n        height: 25px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
